.root {
  height: 64px;
}

.root,
.bars,
.link {
  display: flex;
}

.bars {
  margin-right: 20px;
}

.green {
  border-left: 16px solid #367C2B;
}

.yellow {
  border-left: 6px solid #FFDE00;
}

.image {
  height: 44px;
  margin: auto 0;

  transition: 0.15s ease-in-out filter;
}

.link:hover .image {
  filter: brightness(0.9);
}
